/**
 * @generated SignedSource<<2b45eb9aab6d0cded7478f7b971553db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileAuctionDetailsFallback_nftItem$data = {
  readonly ownerAddress: {
    readonly address: string | null;
    readonly ensDomain: string | null;
    readonly publicProfile: {
      readonly profileName: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "NftItemTileAuctionDetailsFallback_nftItem";
};
export type NftItemTileAuctionDetailsFallback_nftItem$key = {
  readonly " $data"?: NftItemTileAuctionDetailsFallback_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetailsFallback_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileAuctionDetailsFallback_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "ownerAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ensDomain",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "4b9d213eaaaf0d083fcf724048d7c459";

export default node;
